import { useMutation, useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import CampaignService from "services/Campaign";

// ["campaign"] covers the record page, whose key carries the id as a string.
// ["campaigns"] is the Campaigns table key, written out because importing the
// table constants would pull the table module into the form page.
const invalidateCampaigns = () =>
  Promise.all([
    queryClient.invalidateQueries({ queryKey: ["campaign"] }),
    queryClient.invalidateQueries({ queryKey: ["campaigns"] }),
  ]);

export const useCampaign = id =>
  useQuery({
    queryKey: ["campaign", String(id)],
    queryFn: () => CampaignService.getCampaign(id),
    enabled: !!id,
    retry: false,
  });

export const useCampaignMutations = () => {
  const create = useMutation({
    mutationFn: data => CampaignService.createCampaign(data),
    onSuccess: invalidateCampaigns,
  });

  const update = useMutation({
    mutationFn: data => CampaignService.editCampaign(data),
    onSuccess: invalidateCampaigns,
  });

  return { create, update };
};
